<template>
  <div
    class="card z-index-2 invoice-card"
    v-if="chartData && loader"
    style="height: 450px"
  >
    <div class="calendar">
      <div
        class="calendar-item"
        :class="selecedIndex == 'All' ? 'selected' : ''"
      >
        <div @click="handleDateClick('All', 'All')">
          <div class="calendar-day"></div>
          <div class="calendar-date pt-2">All</div>
        </div>
      </div>
      <div
        class="calendar-item"
        v-for="(data, index) in dashoardChartData"
        :key="index"
        :class="selecedIndex === index || selecedIndex == index ? 'selected' : ''"
      >
        <div @click="handleDateClick(data.date, index)">
          <div class="calendar-day">{{ data.date.split(", ")[1] }}</div>
          <div class="calendar-date">{{ data.date.split(", ")[0] }}</div>
        </div>
      </div>
    </div>
    <GradientGraphChart
      v-if="loadernew"
      id="chart-line"
      title="Chart"
      description="<i class='fa fa-arrow-up text-success'></i>
      <span class='font-weight-bold'>Chart </span>"
      :chart="chartData"
    />
  </div>
  <div v-else class="card z-index-2 invoice-card" style="height: 450px">
    <Skalatonloader v-if="!loader" />
    <Skalaton class="mt-12" v-if="loader" />
  </div>
</template>

<script>
import GradientGraphChart from "@/examples/Charts/GradientGraphChart.vue";
import Skalaton from "@/components/Skalaton.vue";
import Skalatonloader from "@/components/Skalatonloader.vue";

export default {
  name: "ChartSection",
  components: {
    GradientGraphChart,
    Skalaton,
    Skalatonloader,
  },
  props: {
    chartData: {
      type: Object,
      default: null,
    },
    loader: {
      type: Boolean,
      default: true,
    },
    loadernew: {
      type: Boolean,
      default: false,
    },
    dashoardChartData: {
      type: Array,
      default: () => [],
    },
    selecedIndex: {
      type: [String, Number],
      default: "All",
    },
  },
  methods: {
    handleDateClick(date, index) {
      console.log('ChartSection: Date clicked', { date, index, dateType: typeof date });
      this.$emit('filer', date, index);
    },
  },
};
</script>

<style scoped>
.calendar {
  display: flex;
  justify-content: start;
  padding: 10px;
  background-color: #020024;
}
.calendar-item {
  width: 56px;
  height: 59px;
  background-color: #444;
  color: #fff;
  text-align: center;
  border-radius: 10px;
  padding: 4px;
  font-size: 14px;
  margin-right: 24px !important;
}
.calendar-item.selected {
  background-color: #98ffcc;
  color: black;
}
.calendar-day {
  font-size: 12px;
}
.calendar-date {
  font-size: 20px;
  font-weight: bold;
}
</style>

